import { http } from '../index';
import Config from '../config/config';

const volt = ({money,loader})=>{
  return http.post({ url: Config.Balance.Volt.replace("{money}",money), loader: loader });
}
const slot = ({operator,loader,data})=>{
  return http.post({ url: Config.Balance.Slot.replace("{operator}",operator).replace("{from}",data?.from).replace("{money}",data?.money), loader: loader });
}
const playTech = ({loader,data})=>{
  return http.post({ url: Config.Balance.PlayTech.replace("{from}",data?.from).replace("{money}",data?.money), loader: loader });
}
const evolution = ({loader,data})=>{
  return http.post({ url: Config.Balance.Evolution.replace("{from}",data?.from).replace("{money}",data?.money), loader: loader });
}
const leaderRoulette = ({loader,data})=>{
  return http.get({ url: Config.Balance.LeaderRoulette.replace("{money}",data?.money), loader: loader });
}
const exitEvolution = ()=>{
  return http.post({ url: Config.Balance.ExitEvolution });
}
const exitJetX = ()=>{
  return http.post({ url: Config.Balance.ExitJetX});
}
const exitPlayTech = ()=>{
  return http.post({ url: Config.Balance.ExitPlayTech });
}
const exitLeaderRoulette = ()=>{
  return http.post({ url: Config.Balance.ExitLeaderRoulette });
}

export default {
  volt,
  slot,
  playTech,
  evolution,
  leaderRoulette,
  exitEvolution,
  exitPlayTech,
  exitLeaderRoulette,
  exitJetX
}
